export default {
    ContactTypes: { 0: "Keeper", 1: "Hirer", 2: "Driver" },
}